import { useTranslation } from "react-i18next";
import { ThemeToggle } from "../ThemeToggle";
import { LanguageSwitcher } from "./LanguageSwitcher";

export function Nav() {
  const { t } = useTranslation();
  const sections: Array<{ href: string; label: string }> = [
    { href: "#vision",   label: t("nav.vision") },
    { href: "#pipeline", label: t("nav.pipeline") },
    { href: "#drones",   label: t("nav.drones") },
    { href: "#pricing",  label: t("nav.pricing") },
  ];

  return (
    <header className="sticky top-0 z-30 backdrop-blur-md bg-[color:var(--color-app-bg)]/75 border-b border-[color:var(--color-app-edge)]">
      <div className="mx-auto max-w-[1320px] px-6 lg:px-10 h-14 flex items-center justify-between">
        <a href="/" className="flex items-center gap-3 group">
          <img
            src={`${import.meta.env.BASE_URL}logo.png`}
            alt="UltraScan"
            className="w-8 h-8"
          />
          <div className="leading-none">
            <div className="font-display tracking-tight text-lg">UltraScan</div>
            <div className="coord-mono mt-0.5">v0.0.1 · {t("common.operational")}</div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-7 label-mono">
          {sections.map((s) => (
            <a key={s.href} href={s.href} className="hover:text-[color:var(--color-app-text)] transition">
              {s.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <LanguageSwitcher />
          <ThemeToggle />
          <a
            href="/app"
            className="hidden sm:inline-flex items-center gap-2 px-3.5 py-1.5 text-xs font-medium border border-[color:var(--color-app-text)] bg-[color:var(--color-app-text)] text-[color:var(--color-app-bg)] hover:bg-transparent hover:text-[color:var(--color-app-text)] transition-colors"
          >
            {t("common.openDashboard")}
            <span aria-hidden>→</span>
          </a>
        </div>
      </div>
    </header>
  );
}
